export default "__VITE_ASSET__CRqruxYZ__"